import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { Banner } from '../../views/twig/components/Banner';
import { LanguageSelector } from '../twig/components/LanguageSelector';
//(new Analytics()).init();
(new Carousel()).init();
//(new Collapse()).init();
//(new Demo()).init();
//(new Dropdown()).init();
(new LazyLoader()).init();
//(new ScrollSpy()).init();
(new Menu()).init();
(new Banner()).init();
(new LanguageSelector()).init();
// Always at the end
//(new CookiesConsent()).init();
